//import { slick } from "@accessible360/accessible-slick";
import Swiper from "swiper";
import {
    FreeMode,
    Keyboard,
    Navigation,
} from "swiper/modules";
import { debounce } from "../utils/Performance";

// import Swiper and modules styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/a11y";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/keyboard";

class SwiperFeed {
    constructor(element) {
        // Class properties.
        this.el = element;
        this.swiperFeedCarouselEl = this.el.querySelector(".swiper");
        this.swiperFeed = null;
        
        this.init();


        window.addEventListener(
            "resize",
            debounce(() => {
                this.init();
            }, 250),
        );
    }

    init() {
        const isDesktop = window.matchMedia("(min-width: 820px)").matches; 
        if (isDesktop) {
         this.instantiateSwiper();
        } else {
            if (this.swiperFeed) {
                this.swiperFeed.destroy(true, true);
                this.swiperFeed = null;
            }   
        }
        
    }

    instantiateSwiper() {
        // Instantiate the main carousel.

        if (this.swiperFeedCarouselEl) {
           
            this.swiperFeed = new Swiper(this.swiperFeedCarouselEl, {
                //loop: true,
                spaceBetween: 16,
                slidesPerView: 1,
                speed: 500,
                direction: "horizontal",
                //freeMode: true,
                autoHeight: false,
                watchSlidesProgress: true,
                containerMessage: `Festival events feed`,
                grabCursor: true,
                loopPreventsSliding: false,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                breakpoints: {
                    768: {
                         slidesPerView: 3,
                         spaceBetween: 48,
                    },
                },
                navigation: {
                    nextEl: this.el.querySelector(".thumbnail-button-next"),
                    prevEl: this.el.querySelector(".thumbnail-button-prev"),
                },
                modules: [Navigation, Keyboard, FreeMode],
            });
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const swiperFeeds = document.querySelectorAll('.swiper--feed');

    swiperFeeds.forEach((element) => {
        new SwiperFeed(element);
    });
});

export default SwiperFeed;
